import { Text, Flex, Icon, Stack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomButton from "@/components/common/Button";
import MailIcon from "@/assets/svg/tick-circle.svg?react";
import { NAVIGATION_ROUTES } from "@/routes/constants";
import AuthWrapper from "@/layouts/AuthWrapper";

const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  return (
    <AuthWrapper>
      <Flex
        w={"full"}
        maxW={"400px"}
        gap={8}
        borderRadius="md"
        flexDirection="column"
        justifyContent="center"
        bg="white"
      >
        <Icon
          as={MailIcon}
          fill="white"
          boxSize={"56px"}
          p={3}
          borderRadius={"md"}
          bg="primary"
          color={"brand.primary.DEFAULT"}
          border={"1px solid"}
          borderColor={"border.default"}
        />
        <Stack gap={1}>
          <Text
            color={"text.primary"}
            fontSize={{ base: "2xl", lg: "4xl" }}
            fontFamily={"primary"}
            fontWeight={"semibold"}
          >
            Password reset
          </Text>
          <Text fontSize="sm" color="text.secondary" fontFamily="primary">
            Your password has been successfully reset. Click below to Sign in
            Kurta Sadi.
          </Text>
        </Stack>

        <CustomButton
          width="100%"
          fontSize="md "
          fontWeight="semibold"
          fontFamily={"primary"}
          onClick={() => navigate(NAVIGATION_ROUTES.LOGIN)}
        >
          Back To Sign in
        </CustomButton>
      </Flex>
    </AuthWrapper>
  );
};

export default ResetPasswordSuccess;
